(function ($) {
    "use strict";

    /**
     * Media Query function for javascript
     *
     * @param property {String} Style Property
     * @param value {Number}
     * @param callback {Function} The callback gets a "respond" argument the returns true if the expression is true
     *
     * @returns {*}
     */
    function mediaQuery(property, value, callback) {
        var query       = property.split('-'),
            length      = query.length,
            expression  = (length > 1) ? query[0] : 'equal',
            respond     = false;

        property = (length > 1) ? query[1] : query[0];

        switch(expression) {
            case 'max':
                respond = $( window )[property]() < value;
                break;
            case 'min':
                respond = $( window )[property]() > value;
                break;
            default:
                respond = $( window )[property]() == value;
                break;
        }

        return callback( respond );
    }

    window.mediaQuery = mediaQuery;
})($);
(function($){
    $.fn.filterAttrs = function(attrList, filter) {
        if(this.length === 0) {
            return null;
        }

        var name, value, obj = {},
            attrs = this[0].attributes;

        filter = filter || function(val){return val;};

        if (!Array.isArray(attrList))
            return attrs;

        $.each(attrs, function() {
            name = this.name;
            value = this.value;

            if(attrList.indexOf(name) > -1) {
                obj[name] = filter(value);
            }
        });

        return obj;
    };
})($);
(function ($) {
    "use strict";

    /**
     * Get Delay Of Transition
     * @param {jQuery} el
     * @returns {Number}
     */
    function getDelayTransition (el) {
        return parseFloat(el.css('transition-duration').replace('s', ''))*1000
    }

    /**
     * Set Transition
     *
     * @param {jQuery} el
     * @param {String} startClass
     * @param {String} endClass
     */
    function setTransition (el, startClass, endClass) {
        el.addClass(startClass);
        el.removeClass(endClass);
    }

    /**
     * Revert Transition
     *
     * @param {jQuery} el
     * @param {String} startClass
     * @param {String} endClass
     */
    function revertTransition (el, startClass, endClass) {
        el.addClass(endClass);
        el.removeClass(startClass);
    }

    /**
     * End Sequence CSS Animation
     *
     * @param {jQuery} el
     * @param {String} startClass
     * @param {String} middleClass
     * @param {String} endClass
     * @param {Number} delay [0]
     */
    function setSequence (el, startClass, middleClass, endClass, delay) {
        setTransition(el, middleClass, endClass);
        window.setTimeout(function () {
            el.addClass(startClass);
            el.removeClass(middleClass);
        }, delay || 0);
    }

    /**
     * Start Sequence CSS Animation
     *
     * @param {jQuery} el
     * @param {String} startClass
     * @param {String} middleClass
     * @param {String} endClass
     * @param {Number} delay
     */
    function revertSequence (el, startClass, middleClass, endClass, delay) {
        delay = delay || getDelayTransition(el);
        revertTransition(el, startClass, middleClass);
        window.setTimeout(function () {
            el.removeClass(middleClass);
            el.addClass(endClass)
        }, delay);
    }

    /**
     * Toggle CSS Animation
     *
     * @param {Selector} selector
     * @param {String} startClass
     * @param {String} endClass
     * @param {Function} condition
     *
     * @return {Boolean}
     */
    function toggleTransition (selector, startClass, endClass, condition) {
        var el = $(selector);

        condition = condition || function(){return true;};

        if (el.length < 1 || !condition(startClass, endClass, condition))
            return false;

        if(el.hasClass(startClass)) {
            revertTransition(el, startClass, endClass);
        } else {
            setTransition(el, startClass, endClass);
        }

        return true;
    }

    /**
     * Toggle Sequence CSS Animation
     *
     * @param {Selector} selector
     * @param {String} startClass
     * @param {String} middleClass
     * @param {String} endClass
     * @param {Number} delay
     *
     * @return {Boolean}
     */
    function toggleSequence (selector, startClass, middleClass, endClass, condition, delay) {
        var el = $(selector);

        condition   = condition || function(){return true;};
        delay       = delay || getDelayTransition(el) || 200;

        if (el.length < 1 || !condition(startClass, middleClass, endClass))
            return false;

        if(el.hasClass(startClass)) {
            revertSequence(el, startClass, middleClass, endClass, delay);
        } else {
            setSequence(el, startClass, middleClass, endClass);
        }

        return true;
    }

    window.Transition = {
        getDelayTransition: getDelayTransition,
        setTransition: setTransition,
        revertTransition: revertTransition,
        setSequence: setSequence,
        revertSequence: revertSequence,
        toggleTransition: toggleTransition,
        toggleSequence: toggleSequence
    };
})($);
(function($, Transition){
    if (!('Actions' in window))
        window.Actions = {};

    /**
     * Toggle Expansion Transition
     *
     * @param selector
     * @param method
     * @param condition
     *
     * @return {Boolean}
     */
    function toggleExpansion (selector, method, condition) {
        switch (method) {
            case 'set':
                Transition.setTransition($(selector), 'expand', 'collapse');
                break;

            case 'revert':
                Transition.revertTransition($(selector), 'expand', 'collapse');
                break;

            default:
                return Transition.toggleTransition(selector, 'expand', 'collapse', condition);
                break;
        }

        return true;
    }

    /**
     * Toggle Collapse Transition
     *
     * @param selector
     * @param method
     * @param condition
     *
     * @return {Boolean}
     */
    function toggleCollapse (selector, method, condition) {
        switch (method) {
            case 'set':
                Transition.setTransition($(selector), 'collapse', 'expand');
                break;

            case 'revert':
                Transition.revertTransition($(selector), 'collapse', 'expand');
                break;

            default:
                return Transition.toggleTransition(selector, 'collapse', 'expand', condition);
                break;
        }

        return true;
    }

    function showElements (selector) {
        Transition.setSequence($(selector), 'show', 'hide', 'remove');
    }
    
    function hideElements (selector, delay) {
        Transition.revertSequence($(selector), 'show', 'hide', 'remove', delay || 300);
    }

    function toggleArrows (selector, defaultMin) {
        var el = $(selector),
            parent = el.parent(),
            maxScroll = el.prop('scrollWidth') - el.width();

        defaultMin = defaultMin || 24;

        if (el.scrollLeft() < (maxScroll-defaultMin))
            parent.addClass('slideToStart');
        else
            parent.removeClass('slideToStart');

        if (el.scrollLeft() > defaultMin)
            parent.addClass('slideToEnd');
        else
            parent.removeClass('slideToEnd');
    }

    function disableArrows (selector) {
        var el = $(selector),
            parent = el.parent();

        parent.removeClass('slideToStart');
        parent.removeClass('slideToEnd');
    }

    $.extend(window.Actions, {
        toggleExpansion: toggleExpansion,
        toggleCollapse: toggleCollapse,
        showElements: showElements,
        hideElements: hideElements,
        toggleArrows: toggleArrows,
        disableArrows: disableArrows
    });
})($, Transition);
(function($, Actions, mediaQuery){
    if (!('Behaviors' in window))
        window.Behaviors = {};

    function toggleResponsiveArrows (selector, defaultMin) {
        mediaQuery('max-width', '1024', function (respond) {
            if (respond) {
                $(selector).each(function () {
                    Actions.toggleArrows(this, defaultMin);
                });
            } else {
                $(selector).each(function () {
                    Actions.disableArrows(this);
                });
            }
        });
    }

    function scrollSlider (selector, defaultMin) {
        defaultMin = defaultMin || 24;

        $(window).ready(function () {
            toggleResponsiveArrows(selector, defaultMin);
        });

        $(window).on('resize', function () {
            toggleResponsiveArrows(selector, defaultMin);
        });

        $(selector).on('scroll', function () {
            Actions.toggleArrows(this, defaultMin);
        });
    }

    $.extend(Behaviors, {
        scrollSlider: scrollSlider
    });
})($, Actions, mediaQuery);
(function () {
    function Chain (callback) {
        if (!(this instanceof Chain)) {
            return new Chain(callback);
        }

        return Chain.then(callback);
    }

    Chain.then = function then (callback) {
        callback.then = function (chainedCallback) {
            return Chain.then(function () {
              return chainedCallback(Chain.resolve(callback, arguments));
            });
        };

        return callback;
    };

    Chain.resolve = function resolve (fn, args) {
        return fn.apply(null, args);
    };

    window.Chain = Chain;
})();
(function($, AutoComplete){
    /**
     * FilterItems Constructor
     *
     * @param itemsSelector
     * @param wrapper
     *
     * @constructor
     */
    function FilterItems (itemsSelector, wrapper) {
        this.wrapper        = wrapper || document;
        this.itemsSelector  = itemsSelector;
        this.defaults       = {
            minChars: 1,
            showAll: true,
            manipulate: FilterItems.DEFAULT_MANIPULATOR
        };
    }

    /**
     * Initialize autoComplete
     *
     * @param inputSelector
     * @param callback
     * @param opts
     */
    FilterItems.prototype.onInput = function onInput (inputSelector, callback, opts) {
        var self = this;

        opts = Object.assign({}, this.defaults, opts || {});

        $(inputSelector).each(function () {
            var input   = this,
                items   = self.getItems(input),
                data    = FilterItems.getItemsValues(items),
                sorted  = opts.manipulate.call(data);


            $(input).autocomplete({
                minLength: 1,
                source: sorted.toArray(),
                position: { my : "right top", at: "right bottom" },
                classes: {
                    "ui-autocomplete": "comp-bannerLinksSearch__AC"
                },
                messages: {
                    noResults: AC_noResults,
                    results: function(amount) {
                        return amount + ( amount > 1 ? AC_results : AC_result ) + AC_navigate;
                    }
                },
                select: function( event, ui ) {
                    $(this).val(ui.item.label);
                    callback.call(this, ui.item.label, event);
                    return false;
                }
            });

            // new AutoComplete({
            //     selector: input,
            //     minChars: opts.minChars,
            //     source: function(term, suggest) {
            //         var suggestions = [], i = 0;
            //
            //         if (opts.showAll !== true) {
            //             suggest(sorted);
            //             return;
            //         }
            //
            //         for ( ; i < sorted.length; i++) {
            //             if (~sorted[i].toLowerCase().indexOf(term))
            //                 suggestions.push(sorted[i]);
            //         }
            //
            //         suggest(suggestions);
            //     },
            //     onSelect: function (event, term, result) {
            //         callback.call(this, result, term, event)
            //     }
            // });
        });
    };


    /**
     * Get Items
     *
     * @returns {*|jQuery}
     */
    FilterItems.prototype.getItems = function getItems () {
        return $(this.wrapper).find(this.itemsSelector);
    };

    /**
     * Filter Items
     *
     * @param term
     * @param negative
     *
     * @returns {*|jQuery}
     */
    FilterItems.prototype.filterItems = function (term, negative) {
        return FilterItems.filter(this.getItems(), term, negative);
    };

    /**
     * Sort Items
     *
     * @param term
     *
     * @returns {*|jQuery}
     */
    FilterItems.prototype.sortItems = function (term) {
        return FilterItems.sort(this.getItems(), term);
    };

    /**
     * Get Items attribute values sorted
     *
     * @param selector
     * @param attr
     *
     * @returns {*}
     */
    FilterItems.getItemsValues = function getBannerTexts (selector, attr) {
        var values = $(selector).map(function() {
            return $(this).attr(attr || 'data-value');
        });

        return values.filter(function (index, value) {
            return Array.prototype.indexOf.call(values, value) == index;
        });
    };

    /**
     * FilterItems.filter
     *
     * @param selector
     * @param term
     * @param negative
     *
     * @returns {*|jQuery}
     */
    FilterItems.filter = function (selector, term, negative) {
        return $(selector).filter(function () {
            if (negative)
                return $(this).attr(term.attribute) != term.value;

            return $(this).attr(term.attribute) == term.value;
        });
    };

    /**
     * FilterItems.sort
     *
     * @param selector
     * @param term
     *
     * @returns {*|jQuery}
     */
    FilterItems.sort = function (selector, term) {
        return $(selector).sort(function (a, b) {
            var first   = parseInt($(a).attr(term.attribute)),
                sec     = parseInt($(b).attr(term.attribute));

            if (first > sec)
                return 1;

            if (first < sec)
                return -1;

            return 0;
        });
    };

    /**
     * Default getItems manipulator function
     * @param items
     * @returns {*}
     * @constructor
     */
    FilterItems.DEFAULT_MANIPULATOR = function (items) {
        return items;
    };

    window.FilterItems = FilterItems;
})($, autoComplete);
(function($, Actions, mediaQuery){
    var wrapperSelector     = '.site-header',
        menuBtn             = wrapperSelector + ' .menuBtn';

    $(menuBtn).on('click', function () {
        var self = $(this);
        var ttdelay = 0;

        mediaQuery('min-width', 1025, function (respond) {
            if (respond) {
                Actions.showElements('.site-menu');
                $('.site-menu .closeBtn:visible').focus();
                return;
            }

            if (!self.hasClass('expand')){
                ttdelay = 250;
                $('.site-header .site-nav').show();
            }
            setTimeout( function () {
                Actions.toggleCollapse('.site-nav');
                self.toggleClass('expand');

                if (self.hasClass('expand')){
                    $('body').addClass('popup-open');
                    $('.site-menu__link:focusable').first().focus();
                } else {
                    $('body').removeClass('popup-open');
                    setTimeout( function () {
                        $('.site-header .site-nav').removeAttr("style");
                    },250);
                }
            }, ttdelay)
        });
    });

})($, Actions, mediaQuery);
(function(Swiper, Behaviors) {
    var
        prevBtn     = $('<button class="swiper-button-prev"></button>'),
        nextBtn     = $('<button class="swiper-button-next"></button>');

    if (!$('body').hasClass('editMode')) {
        $('.nowrap-row').each(function () {
            var row         = $(this),
                body        = row.find('.row-body'),
                components  = body.find(".elemWrapper"),
                isMobile    = row.hasClass('mobile');

            if (isMobile) {
                Behaviors.scrollSlider(body);
                return;
            }

            body.addClass("swiper-wrapper");
            components.addClass("swiper-slide");

            if (row.find('.swiper-button-prev').length < 1)
                row.prepend(prevBtn.clone());

            if (row.find('.swiper-button-next').length < 1)
                row.append(nextBtn.clone());

            new Swiper(this, {
                speed: 800,
                preventClicks: false,
                allowTouchMove: false,
                slidesPerView: 4,
                spaceBetween: 0,
                loop: false,
                autoplay: false,
                direction: 'horizontal',
                autoplayDisableOnInteraction: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                breakpoints: {
                    1024: {
                        slidesPerView: 'auto',
                        autoResize: true
                    }
                }
            });
        });
    }
})(Swiper, Behaviors);
(function(Actions){
    $('.innerpages.orgTourModule.detailsPage')
        .find('.flight-order-details__remarks-header')
        .on('click', function () {
            var self = this;
            
            mediaQuery('max-width', 1024, function (respond) {
                if (respond) {
                    Actions.toggleExpansion(self);
                    Actions.toggleExpansion('.flight-order-details__remarks-moduleText.orgTour');
                }
            });
        });
})(Actions, mediaQuery);
(function(Behaviors) {
    Behaviors.scrollSlider('.comp-searchEngine__tabs');
})(Behaviors);
(function($, Actions, FilterItems){
    function BannerLinks (selectors, attrs) {
        this.selectors = selectors;
        this.attrs = attrs;

        this.loadBtnSelector    = selectors.loadBtn;
        this.moreBtnSelector    = selectors.moreBtn;
        this.bannerSelector     = selectors.banner;
        this.invisibleSelector  = selectors.invisible;
    }

    BannerLinks.prototype = {
        /**
         * Load Banners
         */
        loadBanners: function loadBanners (wrapper, items) {
            items = items || $(wrapper).find(this.bannerSelector);

            var numOfItems  = 0,
                itemsToLoad = [],
                data        = this.getData(wrapper),
                limitPassed = BannerLinks.hasPassedLimit(items.length, data['data-rows'], data['data-perrow']);

            if (limitPassed) {
                numOfItems = data['data-maxrows']*data['data-perrow'];
                itemsToLoad = items.filter(this.invisibleSelector);
                itemsToLoad.each(function (i) {
                    if (i >= numOfItems)
                        return;

                    Actions.showElements(itemsToLoad[i]);
                });

                $(wrapper).attr('data-rows', data['data-rows']+data['data-maxrows']);
            }

            this.handleLoadBtn(wrapper, items);
        },

        /**
         * Handle load buttons
         * @param items
         */
        handleLoadBtn: function handleLoadBtn (wrapper, items) {
            if (this.limitPassed(wrapper, items)) {
                Actions.showElements($(wrapper).find(this.loadBtnSelector));
                Actions.hideElements($(wrapper).find(this.moreBtnSelector));
            } else {
                Actions.showElements($(wrapper).find(this.moreBtnSelector));
                Actions.hideElements($(wrapper).find(this.loadBtnSelector));
            }
        },

        /**
         * Check if items passed the maximum items number
         * @param items
         * @param length
         */
        limitPassed: function limitPassed (wrapper, items, length) {
            var data = this.getData(wrapper);

            length = typeof length === 'number' ? length : items.length;

            return BannerLinks.hasPassedLimit(length, data['data-rows'], data['data-perrow']);
        },

        /**
         * Get bannerLinks data attributes
         * @returns {jQuery}
         */
        getData: function getData (wrapper) {
            return $(wrapper).filterAttrs(this.attrs.bannerLinks, parseInt);
        }
    };

    /**
     * Has passed the maximum items number
     *
     * @param num
     * @param rows
     * @param perRow
     *
     * @returns {boolean}
     */
    BannerLinks.hasPassedLimit = function hasPassedLimit (num, rows, perRow) {
        return num > rows*perRow;
    };
    
    window.BannerLinks = BannerLinks;
})($, Actions, FilterItems);
(function(Actions, FilterItems, BannerLinks, Chain){

    /**
     *
     * @type {{parent: string, wrapper: string, tabsWrapper: string, tabs: string, banner: string, visible: string, loadBtn: string, moreBtn: string, input: string}}
     */
    var selectors = {
        parent:         '.comp-bannerLinksSearch',
        wrapper:        '.comp-bannerLinks',
        inner:          '.comp-bannerLinks__inner',
        tabsWrapper:    '.comp-bannerLinksSearch__tabs',
        tab:            '.comp-bannerLinksSearch__tab',
        banner:         '.bannerLink',
        filtered:       '.filteredBanners',
        visible:        '.show',
        invisible:      '.remove',
        active:         '.active',
        loadBtn:        '.loadMoreButton',
        moreBtn:        '.moreLink',
        input:          'input[name="search-banner-links"]'
    };

    /**
     *
     * @type {{bannerLinks: string[], dataPriority: string, dataFilter: string, dataValue: string, dataVal: string}}
     */
    var attrs = {
        bannerLinks: [
            'data-rows',
            'data-maxrows',
            'data-perrow'
        ],
        dataPriority:'data-priority',
        dataFilter: 'data-filter',
        dataValue: 'data-value',
        dataVal: 'data-val'
    };


    /**
     * BannersLinks Instantiation
     */
    var bannerLinks = new BannerLinks(selectors, attrs);

    /**
     * FilterBanners Constructor
     * Inherits FilterItems Constructor
     *
     * @param component
     * @param wrapper
     * @param bannerSelector
     *
     * @constructor
     */
    function FilterBanners (component, wrapper, bannerSelector) {
        FilterItems.call(this, bannerSelector, wrapper);
        this.component = component;
    }

    /**
     * Inherits FilterItems prototype
     * @type {FilterItems}
     */
    FilterBanners.prototype = Object.create(FilterItems.prototype);

    /**
     * Filter by a pre-define method
     *
     * @param method
     * @param data
     *
     * @returns {boolean}
     */
    FilterBanners.prototype.filterBy = function filterBy (method, data, keepState) {
        if (method != 'FILTERED' && keepState !== true)
            this.filterBy('FILTERED');

        if (method in FilterBanners.filters)
            FilterBanners.filters[method](this, data);

        return true;
    };

    /**
     * Filters
     * @type {Object}
     */
    FilterBanners.filters = {
        FILTERED: function (self) {
            var wrapper     = $(self.wrapper),
                parent      = wrapper.closest(selectors.parent),
                inner       = wrapper.find(selectors.inner),
                filtered    = parent.find(selectors.filtered).find(selectors.banner);

            wrapper.attr('data-rows', wrapper.attr('data-maxrows'));

            if (filtered.length > 0)
                inner.append(filtered);
        },

        ALL: function (self) {
            var
                manipulator = FilterBanners.manageWantedByVisibility(self),
                items       = manipulator({wanted: self.getItems()}),
                wanted      = items.wanted,
                visible     = items.visible,
                hidden      = items.hidden;

            self.handleLoadBtn(wanted);
            FilterBanners.order(wanted, 0);
            FilterBanners.showWanted(visible, hidden);
        },

        PRIORITY: function (self) {
            var
                manipulator =
                    Chain(FilterBanners.sortByAttr({attribute: attrs.dataPriority}))
                        .then(FilterBanners.filterByPriority('sorted'))
                        .then(FilterBanners.manageWantedByVisibility(self))
                        .then(FilterBanners.mergeUnwantedWithHidden(self));

            var
                items       = manipulator(self.getAll()),
                sorted      = items.sorted,
                wanted      = items.wanted,
                visible     = items.visible,
                unwanted    = items.unwanted;

            self.handleLoadBtn(wanted);
            FilterBanners.order(sorted, function(i){return i;});
            FilterBanners.showWanted(visible, unwanted);
        },

        TITLE: function (self, data) {
            self.deactivateTabs();

            var resultText = data.selection;

            if (data.selection instanceof jQuery) {
                resultText = data.selection.attr(attrs.dataVal);
            }

            var
                manipulator =
                    Chain(FilterBanners.sortByAttr({attribute: attrs.dataPriority}))
                        .then(FilterBanners.filterByTitle(resultText, null, 'sorted'))
                        .then(FilterBanners.manageUnwantedByVisibility(self));

            var
                parent      = $(self.wrapper).closest(selectors.parent),
                items       = manipulator(self.getAll()),
                sorted      = items.sorted,
                wanted      = items.wanted,
                unwanted    = items.unwanted,
                hidden      = items.hidden,
                visible     = items.visible;

            self.handleLoadBtn(unwanted);
            FilterBanners.order(sorted, function(i){return i;});
            FilterBanners.hideUnwanted(visible, hidden, function () {
                parent.find(selectors.filtered).append(wanted);
                Actions.showElements(wanted);
            });
        }
    };

    /**
     * Get all items
     * @returns {{wanted: (*|jQuery)}}
     */
    FilterBanners.prototype.getAll = function getAll () {
        return {all: this.getItems()};
    };

    /**
     * Get only visible items
     * @param items
     * @returns {*}
     */
    FilterBanners.prototype.filterHidden = function filterHidden (items) {
        var self = this;

        return items.filter(function (i) {
            return !self.limitPassed(items, i + 1);
        });
    };

    /**
     * Get only hidden items
     * @param items
     * @returns {*}
     */
    FilterBanners.prototype.filterVisible = function filterVisible (items) {
        var self = this;

        return items.filter(function (i) {
            return self.limitPassed(items, i + 1);
        });
    };

    /**
     * Handle load buttons
     * @param items
     */
    FilterBanners.prototype.handleLoadBtn = function handleLoadBtn (items) {
        return bannerLinks.handleLoadBtn(this.wrapper, items);
    };

    /**
     * Check if items passed the maximum items number
     * @param items
     * @param length
     */
    FilterBanners.prototype.limitPassed = function limitPassed (items, length) {
        return bannerLinks.limitPassed(this.wrapper, items, length);
    };

    /**
     * Get bannerLinks data attributes
     * @returns {jQuery}
     */
    FilterBanners.prototype.getData = function getData () {
        return bannerLinks.getData(this.wrapper);
    };

    /**
     * Deactivate Tabs
     */
    FilterBanners.prototype.deactivateTabs = function deactivateTabs () {
        var tabs = $(this.component).find(selectors.tab);
        tabs.removeClass('active');
    };

    /**
     * Sort manipulator
     * @param term
     * @returns {Function}
     */
    FilterBanners.sortByAttr = function sortByAttr (term, key) {
        return function (items) {
            var allItems = items[key || 'all'];
            return Object.assign(items, { sorted: FilterItems.sort(allItems, term) });
        };
    };

    /**
     * Manipulator that filters items by a giving title value
     *
     * @param value
     * @param attribute
     *
     * @returns {Function}
     */
    FilterBanners.filterByTitle = function filterByTitle (value, attribute, key) {
        return function (items) {
            var allItems    = items[key || 'all'],
                attribute   = attribute || attrs.dataValue,
                unwanted    = FilterItems.filter(allItems, { value: value, attribute: attribute }, true),
                wanted      = FilterItems.filter(allItems, { value: value, attribute: attribute });

            return Object.assign(items, {
                unwanted: unwanted,
                wanted: wanted
            });
        };
    };

    /**
     * Manipulator that filters items by priority
     * @returns {Function}
     */
    FilterBanners.filterByPriority = function filterByPriority (key) {
        return function (items) {
            var allItems    = items[key || 'all'],
                unwanted    = FilterItems.filter(allItems, {value: 0, attribute: 'data-priority'}),
                wanted      = FilterItems.filter(allItems, {value: 0, attribute: 'data-priority'}, true);

            return Object.assign(items, {
                unwanted: unwanted,
                wanted: wanted
            });
        };
    };

    /**
     * Manipulator that separate hidden from visible
     *
     * @param obj {FilterBanners}
     * @param key {String}
     *
     * @returns {Function}
     */
    FilterBanners.manageByVisibility = function manageWantedByVisibility (obj, key) {
        return function (items) {
            var wanted  = items[key],
                visible = obj.filterHidden(wanted),
                hidden  = obj.filterVisible(wanted);

            return Object.assign(items, {
                visible: visible,
                hidden: hidden
            });
        };
    };

    /**
     * Manipulator that separate hidden from visible from wanted items
     * @param obj {FilterBanners}
     * @returns {Function}
     */
    FilterBanners.manageWantedByVisibility = function manageUnwantedByVisibility (obj) {
        return FilterBanners.manageByVisibility(obj, 'wanted');
    };

    /**
     * Manipulator that separate hidden from visible from unwanted items
     * @param obj {FilterBanners}
     * @returns {Function}
     */
    FilterBanners.manageUnwantedByVisibility = function manageUnwantedByVisibility (obj) {
        return FilterBanners.manageByVisibility(obj, 'unwanted');
    };

    /**
     * Manipulator merge unwanted items with hidden items
     * @param obj {FilterBanners}
     * @returns {Function}
     */
    FilterBanners.mergeUnwantedWithHidden = function mergeUnwantedWithVisible (obj) {
        return function (items) {
            var unwanted    = items.unwanted,
                hidden      = items.hidden;

            return Object.assign(items, {
                unwanted: $.merge(unwanted, hidden)
            });
        };
    };

    /**
     * Activate Tab
     * @param el
     */
    FilterBanners.activateTab = function activateTab(el) {
        var tabs,
            tab = $(el),
            wrapper = tab.closest(selectors.tabsWrapper);

        if (tab.hasClass('active'))
            return;

        tabs = wrapper.find(selectors.tab);
        tabs.removeClass('active');
        tab.addClass('active');
    };

    /**
     * Hide unwanted items first and then show wanted items later
     *
     * @param wanted
     * @param unwantedItems
     * @param callback
     */
    FilterBanners.showWanted = function hideBanners (wanted, unwantedItems, callback) {
        callback = callback || function(){};

        Actions.hideElements(unwantedItems, 200);
        setTimeout(function () {
            Actions.showElements(wanted);
            callback();
        }, 200);
    };

    /**
     * Show wanted items first and then hide unwanted items later
     *
     * @param wanted
     * @param unwantedItems
     * @param callback
     */
    FilterBanners.hideUnwanted = function hideBanners (wanted, unwantedItems, callback) {
        callback = callback || function(){};

        Actions.showElements(wanted, 200);
        setTimeout(function () {
            Actions.hideElements(unwantedItems, 200);
            callback();
        }, 200);
    };

    /**
     * Order items by a giving function
     *
     * @param items
     * @param fn
     */
    FilterBanners.order = function order (items, fn) {
        $(items).each(function (i, v) {
            this.style.order = (typeof fn == 'function') ? fn(i, v) : fn;
        });
    };

    /**
     * Load Banners
     */
    $(selectors.wrapper).each(function () {
        var wrapper = $(this);

        wrapper.find(selectors.loadBtn).on('click', function(){
            var parent = wrapper.closest(selectors.parent);

            if (parent.length > 0 && parent.find(selectors.tab + selectors.active).length > 0)
                return;

            bannerLinks.loadBanners($(this).closest(selectors.wrapper));
        });

        bannerLinks.handleLoadBtn(wrapper, wrapper.find(selectors.banner));
    });


    /**
     * Instantiation of FilterBanners for each `bannerLinksSearch` component
     */
    $(selectors.parent).each(function () {
        var component       = $(this),
            wrapper         = component.find(selectors.wrapper),
            input           = component.find(selectors.input),
            tabsWrapper     = component.find(selectors.tabsWrapper),
            filterTabs      = tabsWrapper.find(selectors.tab),
            chosenTab       = tabsWrapper.find(selectors.tab + selectors.active),
            loadBtn         = wrapper.find(selectors.loadBtn),
            searchBanner    = new FilterBanners(component, wrapper, selectors.banner);

        filterTabs.on('click', function () {
            var method = $(this).attr(attrs.dataFilter);
            searchBanner.filterBy(method);
            FilterBanners.activateTab(this);
        });

        loadBtn.on('click', function (e) {
            var data = searchBanner.getData(),
                chosenTab = tabsWrapper.find(selectors.tab + selectors.active);

            if (chosenTab.length < 1) {
                e.preventDefault();
                return false;
            }

            wrapper.attr('data-rows', data['data-rows']+data['data-maxrows']);
            searchBanner.filterBy(chosenTab.attr(attrs.dataFilter), {}, true);
        });

        searchBanner.onInput(
            input,
            function (result) {
                searchBanner.filterBy('TITLE', {selection: result});
            },
            {
                manipulate: Array.prototype.sort
            }
        );

        searchBanner.filterBy(chosenTab.attr(attrs.dataFilter));
    });

    window.FilterBanners = FilterBanners;
    window.bannerLinksSearch =  {
        selectors: selectors,
        attrs: attrs
    };

})(Actions, FilterItems, BannerLinks, Chain);